import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiEdit2, FiTrash2 } from 'react-icons/fi';
import { ConfirmationDialog, PageHeader, useToast } from 'components/admin';
import { Button, Select, Table } from 'components/common';
import { deleteIntroduceOrientation, getAdminIntroduceOrientations } from 'apis/adminIntroduce';
import { useAdminDeleteMutation, useAdminListQuery } from 'hooks';
import '../../../styles/admin-shared.scss';

const IntroduceOrientationsList = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [isActiveFilter, setIsActiveFilter] = useState('');
    const [deleteId, setDeleteId] = useState(null);
    const toast = useToast();
    const navigate = useNavigate();

    const queryParams = useMemo(() => ({
        pageNumber: currentPage,
        pageSize,
        isActive: isActiveFilter === '' ? undefined : isActiveFilter === 'true',
    }), [currentPage, pageSize, isActiveFilter]);

    const { data = { items: [], total: 0, currentPage, pageSize }, isFetching, error } = useAdminListQuery('introduce-orientations', queryParams, getAdminIntroduceOrientations);
    const deleteMutation = useAdminDeleteMutation('introduce-orientations', deleteIntroduceOrientation);

    useEffect(() => {
        setCurrentPage(1);
    }, [isActiveFilter]);

    useEffect(() => {
        if (error) toast.error(error.message || 'Tải dữ liệu thất bại');
    }, [error, toast]);

    const handleDelete = async () => {
        try {
            const res = await deleteMutation.mutateAsync(deleteId);
            if (res.success) { toast.success('Xóa thành công'); } else toast.error(res.message);
        } catch { toast.error('Xóa thất bại'); }
        setDeleteId(null);
    };

    const columns = [
        { field: 'id', header: 'ID' },
        { field: 'introduceMenuName', header: 'Menu Giới thiệu' },
        {
            header: 'Hình ảnh',
            render: (row) => row.image ? <img src={row.image} alt="img" style={{ width: 60, height: 40, objectFit: 'cover', borderRadius: 4 }} /> : <span style={{ color: '#ccc', fontSize: 12 }}>Chưa có</span>,
        },
        { field: 'sortOrder', header: 'Thứ tự' },
        { header: 'Trạng thái', render: (row) => <span className={`status-badge ${row.isActive ? 'active' : 'inactive'}`}>{row.isActive ? 'Hoạt động' : 'Không hoạt động'}</span> },
        { header: 'Thao tác', render: (row) => <div className="action-buttons"><button className="icon-btn icon-btn--edit" onClick={() => navigate(`/admin/introduce-orientations/edit/${row.id}`)} title="Sửa"><FiEdit2 size={15} /></button><button className="icon-btn icon-btn--delete" onClick={() => setDeleteId(row.id)} title="Xóa"><FiTrash2 size={15} /></button></div> },
    ];

    return (
        <div className="admin-page">
            <PageHeader title="Định hướng (Orientations)" subtitle="Quản lý hình ảnh định hướng phát triển" action={<Button onClick={() => navigate('/admin/introduce-orientations/create')}>+ Thêm mới</Button>} />
            <div className="filters-bar">
                <div className="filter-item"><Select value={isActiveFilter} onChange={e => setIsActiveFilter(e.target.value)} options={[{ value: '', label: 'Tất cả trạng thái' }, { value: 'true', label: 'Hoạt động' }, { value: 'false', label: 'Không hoạt động' }]} /></div>
            </div>
            <Table columns={columns} data={data.items} loading={isFetching} pagination={{ currentPage: data.currentPage, totalPages: Math.ceil(data.total / data.pageSize) || 1, onPageChange: setCurrentPage }} />
            <ConfirmationDialog open={!!deleteId} onClose={() => setDeleteId(null)} onConfirm={handleDelete} title="Xóa" message="Bạn có chắc chắn muốn xóa không?" />
        </div>
    );
};

export default IntroduceOrientationsList;
